module.exports = __webpack_public_path__ + "static/img/img_moxing_005.456afbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_moxing_005.png
// module id = 5z8u
// module chunks = 19